import {
  EmployerListItemForVerificationRequestInfoFragment,
  VerificationRequestType,
} from 'src/api';

export enum ConsumersMyVerifyFields {
  companyName = 'companyName',
  firstName = 'firstName',
  lastName = 'lastName',
  contactEmail = 'contactEmail',
  noteToRecipient = 'noteToRecipient',
  employers = 'employers',
}

export type ConsumersMyVerifyValues = {
  [ConsumersMyVerifyFields.companyName]: string;
  [ConsumersMyVerifyFields.firstName]: string;
  [ConsumersMyVerifyFields.lastName]: string;
  [ConsumersMyVerifyFields.contactEmail]: string;
  [ConsumersMyVerifyFields.employers]: EmployerListItemForVerificationRequestInfoFragment[];
  [ConsumersMyVerifyFields.noteToRecipient]: string;
};

export enum StatusForm {
  request = 'request',
  anotherRequest = 'anotherRequest',
}

export type EmployeeMyVerifyFormForAnotherRequestProps = {
  verificationType: VerificationRequestType;
  setVerificationType: React.Dispatch<React.SetStateAction<VerificationRequestType>>;
  setStatusForm: React.Dispatch<React.SetStateAction<StatusForm>>;
};

export type EmployeeMyVerifyFormForRequestProps = {
  verificationType: VerificationRequestType;
  setVerificationType: React.Dispatch<React.SetStateAction<VerificationRequestType>>;
  setStatusForm: React.Dispatch<React.SetStateAction<StatusForm>>;
};
